(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa', [
            'ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngFileUpload',
            'ngMaterial',
            'ui.router',
            'angular-loading-bar',
            'angular.filter',
            'LocalStorageModule',
            'pascalprecht.translate',
            'kendo.directives'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('welcome.login', {
                url: '/login',
                templateUrl: 'app/welcome/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('LoginController', loginController);

    function loginController(appConfig, $window, tokenService, accountService) {
        var vm = this;
        vm.submit = submit;

        function submit() {
            vm.dataLoading = true;
            accountService.login(vm.user, vm.password).then(function (response) {
                tokenService.setTokenInfo({ isAdfs: false, token: response.data.access_token });
                $window.location.href = appConfig.getBaseUrl() + '/token';
            },function () {
                vm.dataLoading = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('welcome.doubleLogin', {
                url: '/doubleLogin',
                templateUrl: 'app/welcome/doubleLogin/doubleLogin.html',
                controller: 'DoubleLoginController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('DoubleLoginController', doubleLoginController);

    function doubleLoginController(appConfig, $state, $window, tokenService) {
        var vm = this;

        var tokenInfo = tokenService.getTokenInfo();
        if (tokenInfo) {
            $state.go("initial");
        }

        vm.adfs = adfs;
        vm.token = token;

        function adfs() {
            tokenService.setTokenInfo({isAdfs : true});
            $window.location.href = appConfig.getBaseUrl() + '/adfs';
        }

        function token() {
            $state.go("welcome.login");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('initial', {
                url: '/initial',
                templateUrl: 'app/main/initial/initial.html',
                controller: 'InitialController',
                controllerAs: 'vm'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('InitialController', initialController);

    function initialController($state, accountService) {
        accountService.getCurrentUser().then(function () {
            if (accountService.isAdminWithoutStudent()) {
                $state.go("main.impersonation");
            } else {
                $state.go('main.form');
            }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('main.impersonation', {
                url: '/impersonation/',
                templateUrl: 'app/main/impersonation/impersonation.html',
                controller: 'ImpersonationController',
                controllerAs: 'vm'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('ImpersonationController', ImpersonationController);

    function ImpersonationController($scope, $timeout, $document, accountService, studentGridFactory) {
        var vm = this;
        vm.impersonationGridOptions = studentGridFactory.options(vm.items);
        vm.selectStudent = selectStudent;
        vm.selectedCall = '';
        vm.selectedName = '';
        vm.selectedId = -1;
        vm.selectedDossier = '';
        vm.impersonateStudent = impersonateStudent;
        vm.user = accountService.getCurrentUserData();
        init();

        function init() { }

        function selectStudent(data, dataItem) {
            vm.selectedCall = dataItem.callName;
            vm.selectedName = dataItem.name + ' ' + dataItem.surname1 + ' ' + dataItem.surname2;
            vm.selectedId = dataItem.id;
            vm.selectedDossier = dataItem.dossier;
        }

        function impersonateStudent() {
            if (vm.selectedId != -1) {
                accountService.setImpersionationStudentId(vm.selectedId);
                $document[0].location.href = "/";
            }
        }

        $scope.$on('changedLanguage', function () {
            // Kendo controls could be localized here (look options and k-rebind)                        
            $timeout(function () {
                // Sets language and sets strings again for grid.
                vm.impersonationGridOptions = studentGridFactory.options(vm.items);
            });
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('ieOmpPresentationSpa')
		.config(routerConfig);

	/** @ngInject */
	function routerConfig($stateProvider) {
		$stateProvider
			.state('main.form', {
				url: '/form',
				templateUrl: 'app/main/form/form.html',
				controller: 'FormController',
				controllerAs: 'vm',
				resolve: {
					formData: ['ompService', function (ompService) {
						return ompService.getForm();
					}]
				}
			});
	}
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('FormController', formController);

    function formController(formData) {
        var vm = this;

        vm.formData = formData.data;
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .directive('ieUserInfo', ieUserInfo);

    /** @ngInject */
    function ieUserInfo() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ieUserInfo/ieUserInfo.html',
            controller: IeUserInfoController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                model: '=model'
            }
        };

        return directive;

        /** @ngInject */
        function IeUserInfoController($scope, $document, accountService) {
            var vm = this;

            vm.user = accountService.getCurrentUserData();

            vm.backgroundImage = vm.user.personId
                ? 'url(./fotos/' + vm.user.personId + '.jpg)'
                : './assets/images/avatar-preview.png';

            vm.logout = function () {
                accountService.logout();
            };

            vm.goToImpersonation = function () {
                accountService.resetUserForImpersonation();
                accountService.getCurrentUser().then(function () {
                    $document[0].location.href = "/";
                });
            };

            $scope.$on("userInfoChanged", function (e, args) {
                vm.user = args;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('ieOmpPresentationSpa').directive('ieStudentInfo', ieStudentInfo);

    /** @ngInject */
    function ieStudentInfo() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ieStudentInfo/ieStudentInfo.html',
            controller: ieStudentInfoController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=data'
            }
        };

        return directive;

        /** @ngInject */
        function ieStudentInfoController() {
        }
    }
})();
(function() {
  'use strict';

  angular.module('ieOmpPresentationSpa').directive('ieHeader', ieHeader);

  /** @ngInject */
  function ieHeader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/ieHeader/ieHeader.html',
      controller: IeHeaderController,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '=model'
      }
    };

    return directive;

    /** @ngInject */
    function IeHeaderController(localizationService) {
      var vm = this;
      vm.languageSelected = localizationService.getCurrentLanguage();

      vm.changeLanguage = function(language) {
        localizationService.setLocale(language);
        vm.languageSelected = localizationService.getCurrentLanguage();
      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .directive('ieStudentDocs', ieStudentDocs);

    /** @ngInject */
    function ieStudentDocs() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ieStudentDocs/ieStudentDocs.html',
            controller: ieStudentDocsController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=data'
            }
        };

        return directive;

        /** @ngInject */
        function ieStudentDocsController($filter, notificationsService, ompService) {
            var vm = this,
                translate = $filter('translate');

            vm.agreementAccepted = false;

            vm.changeStudent = function () {
                ompService.getDocuments(vm.data.studentId).then(function (response) {
                    vm.data = response.data;
                });
            };

            vm.uploadFile = function ($files, type) {
                if ($files.length > 0) {
                    ompService.uploadFile($files[0], type, vm.data.studentId).then(
                        function (response) {
                            vm.data = response.data;
                            notificationsService.showSuccess(translate('components.ieStudentDocs.fileUploadedSuccessfully'));
                        }, function () {
                            notificationsService.showError(translate('components.ieStudentDocs.errorUploadingFile'));
                        });
                }
            };

            vm.deleteFile = function (id) {
                ompService.deleteDocument(id).then(
                    function (response) {
                        vm.data = response.data;
                        notificationsService.showSuccess(translate('components.ieStudentDocs.documentDeletedSuccessfully'));
                    }, function () {
                        notificationsService.showError(translate('components.ieStudentDocs.errorDeletingDocument'));
                    });
            };

            vm.validate = function () {
                ompService.validate(vm.data.studentId).then(
                    function () {
                        notificationsService.showSuccess(translate('components.ieStudentDocs.successValidatingMessage'));
                    }, function () {
                        notificationsService.showError(translate('components.ieStudentDocs.errorValidatingMessage'));
                    });
            };
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .directive('ieFormValidationMsg', ieFormValidationMsg);

    /** @ngInject */
    function ieFormValidationMsg() {
        var directive = {
            restrict: 'E',
            templateUrl:
                'app/components/ieFormValidationMsg/ieFormValidationMsg.html',
            controller: ieFormValidationMsgController,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=data'
            }
        };

        return directive;

        /** @ngInject */
        function ieFormValidationMsgController($filter) {
            var vm = this,
                translate = $filter('translate');

            if (vm.data.isValidForOfficialEnrollment == null) {
                vm.message = {
                    error: null,
                    title: translate('components.ieFormValidationMsg.titleDefaultMsg'),
                    description: translate('components.ieFormValidationMsg.msgDefault')
                };
            } else if (vm.data.isValidForOfficialEnrollment) {
                vm.message = {
                    error: false,
                    title: translate('components.ieFormValidationMsg.titleSuccesstMsg'),
                    description: translate('components.ieFormValidationMsg.msgSuccess')
                };
            } else {
                vm.message = {
                    error: true,
                    title: translate('components.ieFormValidationMsg.titleErrorMsg'),
                    description: translate('components.ieFormValidationMsg.msgError')
                };
            }
        }
    }
})();
(function () {
  'use strict'

  angular.module('ieOmpPresentationSpa').directive('ieFormTitle', ieFormTitle)

  /** @ngInject */
  function ieFormTitle() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/ieFormTitle/ieFormTitle.html',
      controller: ieFormTitleController,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        title: '@',
        subtitle: '@',
        description: '@'
      }
    }

    return directive

    /** @ngInject */
    function ieFormTitleController() {
      //var vm = this;
    }
  }
})();

(function () {
  'use strict'

  angular
    .module('ieOmpPresentationSpa')
    .directive('ieActionBar', ieActionBar);

  /** @ngInject */
  function ieActionBar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/ieActionBar/ieActionBar.html',
      controller: ieActionBarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ieActionBarController() {
      //var vm = this;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .controller('WelcomeController', welcomeController);

    function welcomeController() {
    }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('tokenService', tokenService);


    function tokenService(localStorageService) {
        var service = this,
            TOKEN_KEY = 'tokenKey';
       
        service.setTokenInfo = setTokenInfo;
        service.getTokenInfo = getTokenInfo;
        service.removeTokenInfo = removeTokenInfo;

        function getTokenInfo() {
            return localStorageService.get(TOKEN_KEY);
        }

        function setTokenInfo(data) {
            if (data) {
                localStorageService.set(TOKEN_KEY, data);
            }
        }

        function removeTokenInfo() {
            localStorageService.remove(TOKEN_KEY);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('studentDataService', studentDataService);


    function studentDataService(appConfig, $http) {
        var service = this,
            baseUrl = appConfig.getBaseUrl() + '/api/student/';

        service.getPagedAndSorted = getPagedAndSorted;

        //#region Calls to service

        function getPagedAndSorted(filterParams) {
            var result = $http.post(
                baseUrl + 'filtered',
                JSON.stringify(filterParams), // eslint-disable-line
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            return result;
        }

        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('ompService', ompService);


    function ompService(appConfig, $http, Upload) {
        var service = this,
            baseUrl = appConfig.getBaseUrl() + appConfig.ompServicePath;

        service.getInitialData = getInitialData;
        service.getForm = getForm;
        service.getDocuments = getDocuments;
        service.uploadFile = uploadFile;
        service.deleteDocument = deleteDocument;
        service.validate = validate;

        //#region Calls to service

        function getInitialData() {
            var result = $http({
                url: baseUrl + appConfig.getInitialDataPath,
                method: 'GET'
            });

            return result;
        }

        function getForm() {
            var result = $http({
                url: baseUrl,
                method: 'GET'
            });

            return result;
        }

        function getDocuments(studentId) {
            var result = $http({
                url: baseUrl + appConfig.getDocumentsPath,
                method: 'GET',
                params: {
                    studentId: studentId
                }
            });

            return result;
        }

        function uploadFile(file, documentType, studentId) {
            file.upload = Upload.upload({
                url: baseUrl + 'uploadfile?documentType=' + documentType + '&studentId=' + studentId,
                file: file
            });

            return file.upload;
        }

        function deleteDocument(id) {
            var result = $http({
                url: baseUrl + '/' + id,
                method: 'DELETE'
            });

            return result;
        }

        function validate(studentId) {
            var result = $http({
                url: baseUrl + appConfig.validatePath,
                method: 'POST',
                params: {
                    studentId: studentId
                }
            });

            return result;
        }

        //#endregion
    }
})();
(function() {
  'use strict';

  angular
    .module('ieOmpPresentationSpa')
    .service('notificationsService', notificationsService);

  /* @ngInject */
  function notificationsService($mdToast, $filter) {
    var service = this,
      translate = $filter('translate'),
      position = 'top left',
      delay = 3000;

    service.showInfo = showInfo;
    service.showError = showError;
    service.showWarning = showWarning;
    service.showSuccess = showSuccess;

    var buildToast = function(message, keepMessage, type) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .position(position)
        .hideDelay(delay)
        .toastClass('ie-toast')
        .theme(type + '-toast');

      if (keepMessage) {
        toast
          .hideDelay(0)
          .action(translate('ieSpa.common.labelClose'))
          .highlightAction(true);
      }

      return toast;
    };

    function showInfo(message, keepMessage) {
      $mdToast.show(buildToast(message, keepMessage, 'info'));
    }

    function showError(message, keepMessage) {
      $mdToast.show(buildToast(message, keepMessage, 'error'));
    }

    function showWarning(message, keepMessage) {
      $mdToast.show(buildToast(message, keepMessage, 'warning'));
    }

    function showSuccess(message, keepMessage) {
      $mdToast.show(buildToast(message, keepMessage, 'success'));
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('modalService', modalService);

    function modalService($uibModal) {
        var service = this;

        var modalDefaults = {
            backdrop: true,
            keyboard: true,
            modalFade: true,
            templateUrl: 'app/shared/views/modal.html'
        };

        var modalOptions = {
            closeButtonText: 'Cancel',
            actionButtonText: 'Accept',
            headerText: 'Warning',
            bodyText: 'Are you sure?'
        };

        service.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) {
                customModalDefaults = {};
            }

            //customModalDefaults.backdrop = 'static';
            return service.show(customModalDefaults, customModalOptions);
        };

        service.show = function (customModalDefaults, customModalOptions) {
            //Create temp objects to work with since we're in a singleton service
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            if (!tempModalDefaults.controller) {
                tempModalDefaults.controller = ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                    $scope.modalOptions = tempModalOptions;
                    $scope.modalOptions.ok = function (result) {
                        $uibModalInstance.close(result);
                    };
                    $scope.modalOptions.close = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }];
            }

            return $uibModal.open(tempModalDefaults).result;
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('localizationService', localizationService);

    /** @ngInject */
    function localizationService($translate, $locale, $rootScope, $document, $location) {
        var service = this;

        service.getCurrentLanguage = function () {
            return $translate.use();
        };

        service.getLocalizedData = function (exp) {
            var lang = $translate.use();
            return exp && exp[lang]
                ? exp[lang]
                : '[' + exp + ' {' + $translate.use() + '}]';
        };

        service.getLocale = function () {
            return $translate.use();
        }

        service.setLocale = function (lang) {
            $translate.use(lang);
        };

        var deregistrationOnTranslateChangeSuccess = $rootScope.$on(
            '$translateChangeSuccess',
            function () {
                changeAppTitle();
                changeAngularInternalLocalization();
                setKendoCultureAndMessages();
            }
        );

        $rootScope.$on('$destroy', deregistrationOnTranslateChangeSuccess);

        function changeAppTitle() {
            var pageTitle = angular.element(
                $document[0].querySelector('html head title')
            );
            $translate('ieSpa.common.appName').then(
                function (pageTitleText) {
                    pageTitle.html(pageTitleText);
                },
                function (translationId) {
                    pageTitle.text(translationId);
                }
            );
        }

        function changeAngularInternalLocalization() {
            var lang = $translate.use();

            if (lang == 'es') {
                $locale.DATETIME_FORMATS.MONTH = [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre'
                ];
                $locale.DATETIME_FORMATS.SHORTDAY = [
                    'Dom',
                    'Lun',
                    'Mar',
                    'Mie',
                    'Jue',
                    'Vie',
                    'Sáb'
                ];
                $locale.DATETIME_FORMATS.DAY = [
                    'Dom',
                    'Lun',
                    'Mar',
                    'Mie',
                    'Jue',
                    'Vie',
                    'Sáb'
                ];
            } else {
                $locale.DATETIME_FORMATS.MONTH = [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ];
                $locale.DATETIME_FORMATS.SHORTDAY = [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ];
                $locale.DATETIME_FORMATS.DAY = [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ];
            }

            $rootScope.$broadcast('refreshDatepickers');
        }

        function setKendoCultureAndMessages() {
            var lang = $translate.use();
            var scriptUrl = getAppBaseUrl() + "/vendor/kendo-ui/js/messages/kendo.messages." + lang + ".min.js";
            $.getScript(scriptUrl, function () {
                kendo.culture(lang);
            });
        }

        function getAppBaseUrl() {
            return $location.$$protocol + '://' + $location.$$host + ':' + $location.$$port; // eslint-disable-line
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('initialDataService', initialDataService);


    function initialDataService(ompService) {
        var service = this;

        service.initialData = null;
        service.getInitialData = getInitialData;

        function getInitialData(forceRefresh) {
            if (forceRefresh === true || !service.initialData) {
                return ompService.getInitialData().then(function (response) {
                    service.initialData = response.data;
                    return service.initialData;
                });
            } else {
                return service.initialData;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('httpInterceptorService', httpInterceptorService);

    function httpInterceptorService($q, $window, $injector, appConfig, tokenService) {
        var service = this;

        service.request = function (config) {

            config.headers = config.headers || {};

            if (!config.skipWithCredentials) {
                config.withCredentials = true;
            }

            var tokenInfo = tokenService.getTokenInfo();
            if (tokenInfo && !tokenInfo.isAdfs) {
                config.headers.Authorization = 'Bearer ' + tokenInfo.token;
            }

            return config;
        };

        service.responseError = responseError;

        function responseError(response) {
            
            var translate = $injector.get('$translate');
            var notificationsService = $injector.get('notificationsService');

            translate([
                'omp.httpInterceptorService.errorMessage',
                'omp.httpInterceptorService.errorMessageDataProvided'
            ])
            .then(function (tns) {
                var status = response.status,
                    errorMessage = tns['omp.httpInterceptorService.errorMessage'];

                if (status === 0) {
                    notificationsService.showError(errorMessage);

                } if (status === -1) {
                    notificationsService.showError(errorMessage);
                } else if (status >= 100 && status < 200) { //Informational

                } else if (status >= 200 && status < 300) { //Success

                } else if (status >= 300 && status < 400) { //Redirection

                } else if (status >= 400 && status < 500) { //Client error
                    //utilsService.log(response.data, response.status, response.headers, response.config);
                    var message = errorMessage;
                    if (response.data.message) {
                        message = response.data.message;
                    }

                    //400 Bad request
                    if (status === 400 && response.data.modelState) {
                        message = tns['omp.httpInterceptorService.errorMessageDataProvided'];
                        notificationsService.showWarning(message);
                    } else if (status === 400 && response.data.error_description) {
                        notificationsService.showWarning(response.data.error_description);
                    } else if (status === 401) { //401 Unauthorized
                        goToNoAccessPage();
                    } else if (status === 403) {
                        goToNoAccessPage(); //403 Forbidden
                    } else {
                        //404 Not found
                        notificationsService.showError(message);
                    }
                } else if (status >= 500 && status < 600) { //Server error
                    //utilsService.log(response.data, response.status, response.headers, response.config);
                    message = errorMessage;

                    //500 Internal Server Error
                    //501 Not Implemented
                    //503 Service Unavailable
                    notificationsService.showError(message);
                }

            });

            return $q.reject(response);
        }

        function goToNoAccessPage() {
            var url = appConfig.getBaseUrl() + '/Home/NoAccess';
            $window.location.href = url;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .service('accountService', accountService);

    function accountService(appConfig, $rootScope, $http, $q, localStorageService, $window, $cookies, $state, tokenService) {
        var service = this,
            baseUrl = appConfig.getBaseUrl() + '/api/account/',
            USERINFO_DATA_KEY = 'userInfoData',
            IMPERSONATION_STUDENTID = "Impersonation_StudentId";

        service.getCurrentUser = getCurrentUser;
        service.setCurrentUser = setCurrentUser;
        service.getCurrentUserData = getCurrentUserData;
        service.resetUser = resetUser;
        service.resetUserForImpersonation = resetUserForImpersonation;
        service.login = login;
        service.logout = logout;
        service.isAdminWithoutStudent = isAdminWithoutStudent;
        service.setImpersionationStudentId = setImpersionationStudentId;

        function getCurrentUser() {
            var deferred = $q.defer();

            $http.get(baseUrl + '/userinfo')
                .success(function (response) {
                    setCurrentUser(response);
                    deferred.resolve(response);
                })
                .error(function (error) {
                    resetUser();
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        function getCurrentUserData() {
            return localStorageService.get(USERINFO_DATA_KEY);
        }

        function setCurrentUser(userInfo) {
            if (userInfo) {
                localStorageService.set(USERINFO_DATA_KEY, userInfo);
            }
        }

        function resetUser() {
            localStorageService.remove(USERINFO_DATA_KEY);
            tokenService.removeTokenInfo();
            $cookies.remove(IMPERSONATION_STUDENTID);
        }

        function resetUserForImpersonation() {
            localStorageService.remove(USERINFO_DATA_KEY);
            $cookies.remove(IMPERSONATION_STUDENTID);
        }

        function login(username, password) {
            var loginUrl = appConfig.getBaseUrl() + '/login',
                data = {
                    username: username,
                    password: password,
                    grant_type: "password"
                };

            return $http.post(
                loginUrl,
                $.param(data),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
        }

        function logout() {
            var logoutUrl = appConfig.getBaseUrl() + '/Home/SignOut',
                tokenInfo = tokenService.getTokenInfo();

            resetUser();

            if (tokenInfo && tokenInfo.isAdfs) {
                $window.location.href = logoutUrl;
            }
            else {
                $state.go("welcome.doubleLogin");
            }
        }

        function isAdminWithoutStudent() {
            var user = getCurrentUserData();
            return (user.isAdmin && user.isImpersonated == false);
        }

        function setImpersionationStudentId(studentId) {
            $cookies.put(IMPERSONATION_STUDENTID, studentId);
            getCurrentUser().then(function (result) {
                $rootScope.$broadcast("userInfoChanged", result);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .provider('appConfig', appConfig);

    function appConfig() {
        return {
            $get: function () {
                return {
                    /* Web api methods */
                    getInitialDataPath: 'initialdata',
                    getDocumentsPath: 'documents',
                    validatePath: 'validate',
                    /* Web api flexible url context builder */
                    ompServicePath: '/api/omp/',
                    getBaseUrl: function () {
                        var url = location.href;
                        var protocol = url.substring(0, url.indexOf('://'));
                        var urlWithoutProtocol = url.substr(url.indexOf('://') + 3, url.length);
                        var indexOfWWW = urlWithoutProtocol.indexOf('www.');
                        if (indexOfWWW >= 0) {
                            urlWithoutProtocol = urlWithoutProtocol.substr(indexOfWWW + 4, urlWithoutProtocol.length);
                        }
                        var spaBaseUrl = urlWithoutProtocol.substring(0, urlWithoutProtocol.indexOf('/'));
                        var result = protocol + '://' + spaBaseUrl;

                        return result;
                    }
                };
            }
        };
    }
})();

(function () {
    'use strict'

    angular.module('ieOmpPresentationSpa').config(routerConfig)

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('main', {
            abstract: true,
            templateUrl: 'app/main/main.html',
            controller: 'MainController',
            controllerAs: 'vm',
            resolve: {
                //TODO
            }
        })

        $urlRouterProvider.otherwise(function ($injector) {
            var $state = $injector.get('$state')
            $state.go('initial')
        })
    }
})();
(function () {
  'use strict';

  angular
    .module('ieOmpPresentationSpa')
    .controller('MainController', mainController);

  /** @ngInject */
  function mainController() {
  }
})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .filter('localizeByProperty', localizeByProperty);

    function localizeByProperty(localizationService) {
        return function (stringWithLocalization) {
            return localizationService.getLocalizedData(stringWithLocalization);
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .factory('studentGridFactory', studentGridFactory);

    function studentGridFactory(localizationService, studentDataService) {
        return {
            options: function () {
                return {
                    dataSource: {
                        transport: {
                            read: function (o) {
                                // This approach forces to use $http and common data service with $http interceptors
                                studentDataService.getPagedAndSorted(o.data).success(function (response) {
                                    o.success(response);
                                });
                            }
                        },
                        schema: {
                            data: 'items',
                            total: 'totalItemCount',
                            model: {
                                id: "id",
                                fields: {
                                    id: {
                                        editable: false,
                                        type: "number",
                                        isNullable: false
                                    },
                                    name: { isNullable: false },
                                    surname1: { isNullable: false },
                                    surname2: { isNullable: true },
                                    phone: { isNullable: true },
                                    email: { isNullable: true },
                                    dossier: { isNullable: true },
                                    academicProgramName: { isNullable: false }
                                }
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true
                    },
                    selectable: true,
                    resizable: true,
                    filterable: {
                        mode: "row",
                        operators: {
                            number: {
                                eq: kendo.ui.FilterCell.fn.options.operators.number.eq,
                                neq: kendo.ui.FilterCell.fn.options.operators.number.neq
                            },
                            string: {
                                startswith: kendo.ui.FilterCell.fn.options.operators.string.startswith,
                                contains: kendo.ui.FilterCell.fn.options.operators.string.contains
                            }
                        }
                    },
                    sortable: {
                        mode: "multiple"
                    },
                    pageable: true,
                    language: localizationService.getLocale()
                };
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('ieOmpPresentationSpa').directive('serverValidate', function () {
        return {
            require: 'ngModel',
            link: function (scope, ele, attrs, c) {
                scope.$watch('modelState', function () {
                    if (scope.modelState === null) {
                        return;
                    }

                    var modelStateKey;
                    if (attrs.name) {
                        modelStateKey = attrs.name;
                    }

                    if (scope.modelState && scope.modelState[modelStateKey]) {
                        c.$setValidity('server', false);
                        c.$error.server = scope.modelState[modelStateKey];
                    } else {
                        c.$setValidity('server', true);
                    }
                });

                scope.$watch(attrs.ngModel, function (oldValue, newValue) {
                    if (oldValue !== newValue) {
                        c.$setValidity('server', true);
                        c.$error.server = [];
                    }
                });
            }
        };
    });
})();
(function () {
    'use strict';

    angular
      .module('ieOmpPresentationSpa')
      .config(translateConfig);

    /** @ngInject */
    function translateConfig($translateProvider) {

        // See gulp/translate.js for language file building
        $translateProvider.useStaticFilesLoader({
            prefix: '/translations/locale.',
            suffix: '.json'
        });
        $translateProvider.preferredLanguage('en').fallbackLanguage('es');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.useLocalStorage();
    }

})();

(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope) {
        $rootScope.showHelpTooltips = false;

        $rootScope.toogleHelp = function() {
            $rootScope.showHelpTooltips = !$rootScope.showHelpTooltips;
            $rootScope.$broadcast('help.toggle', { visible: $rootScope.showHelpTooltips });
        }
    }

})();
(function () {
  'use strict'

  angular.module('ieOmpPresentationSpa').config(routerConfig)

  /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $stateProvider.state('welcome', {
            abstract: true,
            templateUrl: 'app/welcome/welcome.html',
            controller: 'WelcomeController',
            controllerAs: 'vm'
    })

    $urlRouterProvider.otherwise(function ($injector) {
      var $state = $injector.get('$state')
      $state.go('welcome.doubleLogin')
    })
  }
})();

/* global */
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .constant('user', {});

})();
(function () {
    'use strict';

    angular
        .module('ieOmpPresentationSpa')
        .config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, $mdThemingProvider, $mdDateLocaleProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

        $httpProvider.interceptors.push('httpInterceptorService');

        $mdThemingProvider.theme('info-toast');
        $mdThemingProvider.theme('error-toast');
        $mdThemingProvider.theme('warning-toast');
        $mdThemingProvider.theme('success-toast');

        $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        $mdDateLocaleProvider.shortMonths = ['Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.', 'Jul.', 'Ago.', 'Sep.', 'Oct.', 'Nov.', 'Dic.'];
        $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        $mdDateLocaleProvider.shortDays = ['D', 'L', 'M', 'X', 'J', 'V', 'S'];
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format('DD/MM/YYYY') : null;
        };
    }

})();
angular.module("ieOmpPresentationSpa").run(["$templateCache", function($templateCache) {$templateCache.put("app/index.html","<!doctype html><html ng-app=ieOmpPresentationSpa class=expand-height><head><meta charset=utf-8><title>IE - Official Master Process</title><meta name=description content=\"\"><meta name=viewport content=\"width=device-width\"><meta http-equiv=X-UA-Compatible content=\"IE=edge\"><link rel=stylesheet type=text/css href=\"//fonts.googleapis.com/icon?family=Material+Icons\"><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><!-- run `gulp inject` to automatically populate bower styles dependencies --><!-- endbower --><!-- endbuild --><link href=../vendor/kendo-ui/styles/kendo.common.min.css rel=stylesheet><link href=../vendor/kendo-ui/styles/kendo.material.min.css rel=stylesheet><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><!-- css files will be automatically insert here --><!-- endinject --><!-- endbuild --></head><body class=expand-height layout=column><!--[if lt IE 9]>\r\n      <p class=\"browsehappy\">You are using an <strong>outdated</strong> browser. Please <a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your experience.</p>\r\n    <![endif]--><md-content><div ui-view class=expand-height></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><!-- run `gulp inject` to automatically populate bower script dependencies --><!-- endbower --><!-- endbuild --><script src=../vendor/kendo-ui/js/kendo.all.min.js></script><script src=../vendor/kendo-ui/js/cultures/kendo.culture.es.min.js></script><script src=../vendor/kendo-ui/js/cultures/kendo.culture.en.min.js></script><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><!-- js files will be automatically insert here --><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><div class=tooltip-help-background ng-show=showHelpTooltips ng-click=toogleHelp()></div></md-content></body></html>");
$templateCache.put("app/main/main.html","<ie-header></ie-header><div class=\"ie-main-container container\"><div ui-view></div></div>");
$templateCache.put("app/welcome/welcome.html","<div class=\"ie-main-container container\"><div ui-view></div></div>");
$templateCache.put("app/components/ieActionBar/ieActionBar.html","<div class=ie-action-bar><!--<button \r\n    class=\"btn--primary pull-right\" \r\n    ui-sref=\"main.newPractice\" \r\n    translate=\"{{\'components.ieActionBar.newInternshipBtn\'}}\">\r\n  </button>--></div>");
$templateCache.put("app/components/ieFormTitle/ieFormTitle.html","<div class=row><div class=\"col-xs-12 ie-title-group\"><h4 ng-if=vm.title translate>{{vm.title}}</h4><h6 ng-if=vm.subtitle translate>{{vm.subtitle}}</h6><p ng-if=vm.description class=secondary-description translate>{{vm.description}}</p></div></div>");
$templateCache.put("app/components/ieFormValidationMsg/ieFormValidationMsg.html","<section class=ie-validation-container ng-class=\"\"><h5 class=fs-14 translate=\"{{ \'components.ieFormValidationMsg.title\' }}\"></h5><div class=ie-validation-msg ng-class=\"{\'ie-validation-msg--valid\': vm.message.error === false, \'ie-validation-msg--invalid\': vm.message.error === true}\"><i ng-if=\"vm.message.error === null\" class=\"ic-line-info fs-32\"></i> <i ng-if=\"vm.message.error === false\" class=\"ic-round-check fs-32\"></i> <i ng-if=\"vm.message.error === true\" class=\"ic-round-warning fs-32\"></i><div class=ie-validation-info><h6>{{vm.message.title}}</h6><p class=ie-validation-info__description>{{vm.message.description}}</p></div></div></section>");
$templateCache.put("app/components/ieStudentDocs/ieStudentDocs.html","<fieldset class=\"ie-form-container ie-students-doc\"><div class=\"row ie-students-doc__padding\"><div class=\"col-xs-12 mb-3\"><h5 translate=\"{{ \'components.ieStudentDocs.documentationTitle\' }}\"></h5></div></div><div class=\"row ie-students-doc__padding\"><div class=col-xs-12><md-input-container><label translate=\"{{ \'components.ieStudentDocs.currentStudies\' }}\"></label><md-select ng-model=vm.data.studentId ng-change=vm.changeStudent()><md-option ng-value=option.value ng-repeat=\"option in vm.data.students\">{{option.text}}</md-option></md-select></md-input-container></div></div><table class=ie-doc-table><thead><tr><th class=align-left width=150px>{{ \'components.ieStudentDocs.requieredDoc\' | translate }}</th><th width=125px></th><th class=align-left width=100px>{{ \'components.ieStudentDocs.documentTitle\' | translate }}</th><th width=60px></th><th class=align-left width=160px>{{ \'components.ieStudentDocs.date\' | translate }}</th><th width=100px>{{ \'components.ieStudentDocs.status\' | translate }}</th></tr></thead><tbody><tr><td translate-attr=\"{title: \'components.ieStudentDocs.officialDegree\'}\">{{ \'components.ieStudentDocs.officialDegree\' | translate }}</td><td class=align-center><button class=ie-upload-file translate=\"{{\'components.ieStudentDocs.uploadFile\'}}\" ngf-select ngf-change=\"vm.uploadFile($files, 3)\" ng-disabled=\"!vm.data.officialDegreeDocument.canEdit || vm.data.officialDegreeDocument.isValidated === true\"></button></td><td><span ng-attr-title={{vm.data.officialDegreeDocument.name}}>{{vm.data.officialDegreeDocument.name}}</span></td><td class=align-center><button class=btn-action ng-click=vm.deleteFile(vm.data.officialDegreeDocument.id) ng-disabled=\"!vm.data.officialDegreeDocument.canEdit || vm.data.officialDegreeDocument.isValidated !== false\"><i class=\"ic-line-delete fs-24\"></i></button></td><td>{{vm.data.officialDegreeDocument.date | date: \"dd/MM/yyyy, HH:mm\"}}</td><td class=align-center><i ng-if=!vm.data.officialDegreeDocument.id class=\"ic-line-faqs fs-24\"></i> <i ng-if=\"vm.data.officialDegreeDocument.id && vm.data.officialDegreeDocument.isValidated === true\" class=\"ic-round-check color-success fs-24\"></i> <i ng-if=\"vm.data.officialDegreeDocument.id && vm.data.officialDegreeDocument.isValidated === false\" class=\"ic-round-warning color-error fs-24\"></i></td></tr><tr><td translate-attr=\"{title: \'components.ieStudentDocs.officialId\'}\">{{ \'components.ieStudentDocs.officialId\' | translate }}</td><td class=align-center><button class=ie-upload-file translate=\"{{\'components.ieStudentDocs.uploadFile\'}}\" ngf-select ngf-change=\"vm.uploadFile($files, 2)\" ng-disabled=\"!vm.data.officialIdentificationDocument.canEdit || vm.data.officialIdentificationDocument.isValidated === true\"></button></td><td><span ng-attr-title={{vm.data.officialIdentificationDocument.name}}>{{vm.data.officialIdentificationDocument.name}}</span></td><td class=align-center><button class=btn-action ng-click=vm.deleteFile(vm.data.officialIdentificationDocument.id) ng-disabled=\"!vm.data.officialIdentificationDocument.canEdit || vm.data.officialIdentificationDocument.isValidated !== false\"><i class=\"ic-line-delete fs-24\"></i></button></td><td>{{vm.data.officialIdentificationDocument.date | date: \"dd/MM/yyyy, HH:mm\"}}</td><td class=align-center><i ng-if=!vm.data.officialIdentificationDocument.id class=\"ic-line-faqs fs-24\"></i> <i ng-if=\"vm.data.officialIdentificationDocument.id && vm.data.officialIdentificationDocument.isValidated === true\" class=\"ic-round-check color-success fs-24\"></i> <i ng-if=\"vm.data.officialIdentificationDocument.id && vm.data.officialIdentificationDocument.isValidated === false\" class=\"ic-round-warning color-error fs-24\"></i></td></tr></tbody></table><div class=\"row ie-students-doc__padding mt-3\"><div class=\"col-md-10 col-sm-8\"><md-input-container><md-checkbox ng-model=vm.agreementAccepted>{{ \'components.ieStudentDocs.agreement\' | translate }}</md-checkbox></md-input-container></div><div class=\"col-md-2 col-sm-4 mt-1\"><button class=\"btn btn--primary pull-right\" ng-disabled=!vm.agreementAccepted ng-click=vm.validate()>{{ \'components.ieStudentDocs.btnLabel\' | translate }}</button></div></div><div class=ie-students-doc__padding><ie-form-validation-msg data=vm.data></ie-form-validation-msg></div></fieldset>");
$templateCache.put("app/components/ieHeader/ieHeader.html","<div class=ie-header__secondary><a href=# translate=\"{{ \'components.ieHeader.english\' }}\" ng-click=\"vm.changeLanguage(\'en\')\" ng-class=\"{\'is-selected\': vm.languageSelected == \'en\'}\"></a> | <a href=# translate=\"{{ \'components.ieHeader.spanish\' }}\" ng-click=\"vm.changeLanguage(\'es\')\" ng-class=\"{\'is-selected\': vm.languageSelected == \'es\'}\"></a></div><header class=ie-header><a class=ie-header__title ui-sref=main.form><div class=ie-header__logo><img src=/assets/images/mainLogo.svg alt=\"Ie logo\"></div><h4 translate=\"{{ \'ieSpa.common.appName\' }}\"></h4></a><div class=ie-header__menu><ie-user-info></ie-user-info></div></header>");
$templateCache.put("app/components/ieUserInfo/ieUserInfo.html","<div class=ie-user-info><div class=ie-user-info__name><h6>{{::vm.user.name}}</h6></div><div class=ie-user-info__image ng-style=\"{\'background-image\': vm.backgroundImage}\" title={{vm.user.name}}></div><div class=ie-user-info__logout ng-click=vm.logout() translate-attr=\"{title: \'components.ieUserInfo.logoutTooltip\'}\"><span class=ic-line-logout></span></div><div class=ie-user-info__logout ng-if=vm.user.isImpersonated ng-click=vm.goToImpersonation() translate-attr=\"{title: \'components.ieUserInfo.goToImpersonationTooltip\'}\"><span class=ic-line-home></span></div></div>");
$templateCache.put("app/components/ieStudentInfo/ieStudentInfo.html","<fieldset class=\"ie-form-container mb-3\"><div class=row><div class=\"col-xs-12 mb-3\"><h5 translate=\"{{ \'components.ieStudentInfo.studentInfoTitle\' }}\"></h5></div></div><div class=row><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentNameLabel\' }}\"></label><input type=text name=name ng-model=vm.data.name disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentMiddleNameLabel\' }}\"></label><input type=text name=surname1 ng-model=vm.data.surname1 disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentLastNameLabel\' }}\"></label><input type=text name=surname2 ng-model=vm.data.surname2 disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentBirthLabel\' }}\"></label><md-datepicker md-hide-icons=all name=birthDate ng-model=vm.data.birthDate disabled></md-datepicker></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container class=md-input-has-value><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentGender\' }}\"></label><md-radio-group ng-model=vm.data.isMale disabled><md-radio-button ng-value=true>{{ \'components.ieStudentInfo.studentGenderMale\' | translate }}</md-radio-button><md-radio-button ng-value=false>{{ \'components.ieStudentInfo.studentGenderFemale\' | translate }}</md-radio-button></md-radio-group></md-input-container></div><div class=\"col-md-2 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentAge\' }}\"></label><input type=text name=age ng-model=vm.data.age disabled></md-input-container></div><div class=\"col-md-2 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentNationalityLabel\' }}\"></label><input type=text name=nationality ng-model=vm.data.nationality disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentPlaceBirth\' }}\"></label><input type=text name=birthPlace ng-model=vm.data.birthPlace disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentDniLabel\' }}\"></label><input type=text name=identificationValue ng-model=vm.data.identificationValue disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentAddressLabel\' }}\"></label><input type=text name=address ng-model=vm.data.address disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentCityLabel\' }}\"></label><input type=text name=city ng-model=vm.data.city disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentStateLabel\' }}\"></label><input type=text name=province ng-model=vm.data.province disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentCountryLabel\' }}\"></label><input type=text name=country ng-model=vm.data.country disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentPhoneLabel\' }}\"></label><input type=text name=phoneNumber ng-model=vm.data.phoneNumber disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentMobileLabel\' }}\"></label><input type=text name=mobileNumber ng-model=vm.data.mobileNumber disabled></md-input-container></div><div class=\"col-md-4 col-sm-6\"><md-input-container><label class=ie-md-disabled-label translate=\"{{ \'components.ieStudentInfo.studentEmailLabel\' }}\"></label><input type=text name=email ng-model=vm.data.email disabled></md-input-container></div></div></fieldset>");
$templateCache.put("app/main/form/form.html","<ie-form-title title=omp.view.form.title></ie-form-title><form><ie-student-docs data=vm.formData.documentation></ie-student-docs></form>");
$templateCache.put("app/main/impersonation/impersonation.html","<div class=impersonation-wrapper><div class=container><div class=row><div class=col-lg-12><h4 translate>{{\'omp.view.impersonation.title\'}}</h4><p translate>{{\'omp.view.impersonation.info\'}}</p><hr><div><div class=panel-body ng-show=\"vm.selectedId!=-1\"><p><strong>{{vm.selectedCall}}</strong>&nbsp; {{vm.selectedName}} ({{vm.selectedDossier}})</p></div><div class=panel-body ng-show=\"vm.selectedId==-1\"><p translate>{{\'omp.view.impersonation.label\'}}</p></div><div class=panel-footer><a class=k-button ng-click=vm.impersonateStudent() ng-disabled=\"vm.selectedId==-1\"><span class=\"k-font-icon k-i-copy\"></span> {{\'omp.view.impersonation.button\' | translate}}</a></div></div><kendo-grid options=vm.impersonationGridOptions k-rebind=vm.impersonationGridOptions.language k-on-change=\"vm.selectStudent(data, dataItem, columns)\" k-columns=\'[\r\n                        {\r\n                            field: \"callName\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleCallName\" | translate}}\",\r\n                            width: \"120px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        },\r\n                        {\r\n                            field: \"academicProgramName\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleProgram\" | translate}}\",\r\n                            width: \"120px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        },\r\n                        {\r\n                            field: \"dossier\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleDossier\" | translate}}\",\r\n                            width: \"120px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        },\r\n                        {\r\n                            field: \"name\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleFirstName\" | translate}}\",\r\n                            width: \"180px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        }, {\r\n                            field: \"surname1\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleFirstLastName\" | translate}}\",\r\n                            width: \"200px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        }, {\r\n                            field: \"surname2\",\r\n                            title: \"{{\"omp.view.impersonation.kGrid.columnTitleSecondLastName\" | translate}}\",\r\n                            width: \"200px\",\r\n                            filterable: {\r\n                                cell: {\r\n                                  minLength: 99999\r\n                                }\r\n                            }\r\n                        }]\'></kendo-grid><p>&nbsp;</p><p>{{ vm.user.machineName }}</p></div></div></div></div>");
$templateCache.put("app/main/initial/initial.html","");
$templateCache.put("app/shared/views/modal.html","<div class=modal-header><button type=button class=close data-dismiss=modal aria-hidden=true></button><h4 class=modal-title>{{modalOptions.headerText}}</h4></div><div class=modal-body><p>{{modalOptions.bodyText}}</p></div><div class=modal-footer><button type=button class=\"btn btn-raised btn-primary\" data-ng-click=modalOptions.close()>{{modalOptions.closeButtonText}}</button> <button class=\"btn btn-raised btn-primary\" data-ng-click=modalOptions.ok();>{{modalOptions.actionButtonText}}</button></div>");
$templateCache.put("app/welcome/doubleLogin/doubleLogin.html","<ie-form-title title=omp.view.doubleLogin.title></ie-form-title><fieldset class=\"ie-form-container mb-3\"><div class=row><div class=\"col-xs-12 mb-3\"><h5 translate=\"{{ \'omp.view.doubleLogin.adfsTitle\' }}\"></h5></div></div><div class=row><div class=\"col-md-12 mb-3\"><button ng-click=vm.adfs() class=\"btn btn--primary\" translate=\"{{\'omp.view.doubleLogin.adfs\'}}\"></button></div></div><div class=row><div class=\"col-xs-12 mb-3\"><h5 translate=\"{{ \'omp.view.doubleLogin.userPasswordTitle\' }}\"></h5></div></div><div class=row><div class=\"col-md-12 mb-3\"><button ng-click=vm.token() class=\"btn btn--primary\" translate=\"{{\'omp.view.doubleLogin.userPassword\'}}\"></button></div></div><div class=row><div class=col-md-12><label translate=\"{{ \'omp.view.doubleLogin.userPasswordDescription\' }}\"></label></div></div></fieldset>");
$templateCache.put("app/welcome/login/login.html","<ie-form-title title=omp.view.login.title></ie-form-title><fieldset class=\"ie-form-container mb-3\"><form name=form novalidate ng-submit=vm.submit()><div class=row><div class=\"col-xs-12 mb-3\"><h5 translate=\"{{ \'omp.view.login.loginTitle\' }}\"></h5></div></div><div class=row><div class=\"col-md-4 col-sm-6\"><md-input-container><label translate=\"{{\'omp.view.login.user\'}}\"></label><input type=text name=userName ng-model=vm.user required><div ng-messages=form.userName.$error><div ng-message=required translate=\"{{ \'ieSpa.common.errorIsRequired\' }}\"></div></div></md-input-container></div></div><div class=row><div class=\"col-md-4 col-sm-6\"><md-input-container><label translate=\"{{\'omp.view.login.password\'}}\"></label><input type=password name=password ng-model=vm.password required><div ng-messages=form.password.$error><div ng-message=required translate=\"{{ \'ieSpa.common.errorIsRequired\' }}\"></div></div></md-input-container></div></div><div class=row><div class=col-md-12><button type=submit ng-disabled=\"form.$invalid || vm.dataLoading\" class=\"btn btn--primary\" translate=\"{{\'omp.view.login.submit\'}}\"></button></div></div></form></fieldset>");}]);